import { RelatedItemsModal } from './RelatedItemsModal'

export default RelatedItemsModal
